import React, { Component} from 'react';
import './Join.css';
import { IconContext } from "react-icons";
import { BiChevronLeft, BiSidebar } from "react-icons/bi";


class Join extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidUpdate(){
    
  }
 
  componentDidMount(){
    
  }

  render() {
    return (
      <div className = "joinPage joinScrollableSec fadeJoinAnimation">
        <div className = "joinHeader">
        </div>
        <div className = "joinContent1">
          <h3> Graduate and Postdoc Research </h3>
          <p>
            Our lab is always looking for motivated and enthusiastic graduate students of all research levels! 
            A formal application can be submitted directly through the graduate application portal, during the student application process. 
            You can also drop me a line with your CV at brx@cs.ubc.ca.
          </p>
          <h3> Undergraduate Research </h3>
          <p>
            We are looking for strong undergraduate researchers with a record of research expertise. 
            Undergraduate students may work on their own independent research projects, or work closely with a graduate student to collaboratively assist. 
            <br></br><br></br>
            If interested, drop me an email at brx@cs.ubc.ca with:
            <ul>
              <li>A brief introduction to yourself and your research interests</li>
              <li>Position you are looking for and what outcomes you would want</li>
              <li>Resume / CV</li>
              <li>UBC Transcript (unofficial is fine)</li>
            </ul>
          </p>
        </div>


      </div>
    )
  }
}

export default Join;
